import { initializeApp } from "firebase/app";
import { getAuth, signOut, onAuthStateChanged, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqNLrFRwtb0cYyaaV-K-dewoO1uQCi-Eg",
  authDomain: "wics-portal-417412.firebaseapp.com",
  projectId: "wics-portal-417412",
  storageBucket: "wics-portal-417412.appspot.com",
  messagingSenderId: "1016618778798",
  appId: "1:1016618778798:web:0a2c79630881b52a8b6d3f",
  measurementId: "G-H04KL6JCLR",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// ES Module export
export { auth, db, storage };